import { render, staticRenderFns } from "./PersonListContainer.vue?vue&type=template&id=3c6e6c24"
import script from "./PersonListContainer.ts?vue&type=script&lang=ts&external"
export * from "./PersonListContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports